import type {
  BreadcrumbSlots as BreadcrumbBaseSlots,
  BreadcrumbBaseProps,
  BreadcrumbBaseState,
  BreadcrumbContextValues as BreadcrumbBaseContextValues,
} from '@fluentui/react-breadcrumb';

/**
 * Breadcrumb component slots
 */
export type BreadcrumbSlots = BreadcrumbBaseSlots;

/**
 * Breadcrumb component props
 */
export type BreadcrumbProps = BreadcrumbBaseProps;

/**
 * Breadcrumb component state
 */
export type BreadcrumbState = BreadcrumbBaseState;

/**
 * Context values provided by Breadcrumb to its sub-components.
 */
export type BreadcrumbContextValues = BreadcrumbBaseContextValues;
